import "./index.css";
import React from "react";
import { TypeIcon } from "../../../../Constants/assets";
import { mediaOptions } from "../../constants";

export default function UploadSelectionModal({
  isOpen,
  onClose,
  onSelect,
  modalRef,
  hex,
}) {
  return (
    <div
      className={`upload-select ${isOpen ? "upload-select--open" : ""}`}
      ref={modalRef}
    >
      <div className="upload-select__content">
        <button
          type="button"
          className="upload-select__close"
          onClick={onClose}
        >
          <span aria-hidden="true" className="upload-select__close-icon">
            &times;
          </span>
        </button>
        <ul className="upload-select__list">
          {mediaOptions.map((option) => (
            <li
              className="upload-select__list-item"
              style={{ "--hex": hex }}
              key={option.title}
              onClick={() => onSelect(option)}
            >
              <img
                src={TypeIcon[option.type]}
                alt={option.alt}
                className="upload-select__icon"
              />
              {option.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/UploadPanel/components/UploadSelectionModal/index.js